var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"theme-toggle",attrs:{"title":_vm.currentTheme === 'light' ? 'dark mode' : 'light mode'},on:{"click":_vm.toggleTheme}},[_vm._v(" "+_vm._s(_vm.currentTheme === 'light' ? '[ dark ]' : '[ light ]')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }